/**
 * @generated SignedSource<<3e6ed29700475c46a282b5a8966df484>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatedContactSellerForm_transaction$data = {
  readonly buyer: {
    readonly profile: {
      readonly displayName: string | null;
      readonly email: string | null;
    } | null;
  } | null;
  readonly item: {
    readonly seller: {
      readonly serviceId: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "UpdatedContactSellerForm_transaction";
};
export type UpdatedContactSellerForm_transaction$key = {
  readonly " $data"?: UpdatedContactSellerForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdatedContactSellerForm_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdatedContactSellerForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "buyer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "2171c19bf2ad4fd5e95e1c6caa2b56a9";

export default node;
